export default __webpack_public_path__ + "static/media/bullhorn-solid.344da4c4.svg";